module.exports = __webpack_public_path__ + "static/img/自然師資介紹.2b9249bd.png";